<template>
  <section class="section">
    <div class="px-2">
      <div class="columns is-desktop">
        <div class="column is-2">
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="filterField">
                  <option value="email">Email</option>
                  <option value="stripeId">Stripe customer id</option>
                  <option value="companyName">Company Name</option>
                  <option value="vatID">VAT ID</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <div class="control">
            <input type="text" v-on:keyup.enter="onFilter" class="input" placeholder="Search" v-model="searchText">
          </div>
        </div>
        <div class="column is-2">
          <date-picker v-model="dates" range></date-picker>
        </div>
        <div class="column is-4">
          <v-btn rounded small
            color="profileAnchorColor"
            class="button-with-icon text-none whiteColor--text ml-2 mr-1"
            @click="onFilter">Search</v-btn>
          <v-btn rounded small
            color="profileAnchorColor"
            class="button-with-icon text-none whiteColor--text mr-1"
            @click="exportCsv">Export to CSV</v-btn>
        </div>
        <div class="column">
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="perPage">
                  <option value="10">10 per page</option>
                  <option value="15">15 per page</option>
                  <option value="25">25 per page</option>
                  <option value="50">50 per page</option>
                  <option value="100">100 per page</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="totalPaid" class="mb-4 text-right mainColor--text font-weight-bold" style="font-size: 1rem;">
        Total paid: {{ formatCurrency(totalPaid) }}
      </div>
      
      <b-table
        :data="users"
        ref="userTable"
        paginated
        backend-pagination
        :total="total"
        :per-page="perPage"
        @page-change="onPageChange"
        :current-page="currentPage"
        backend-sorting
        :default-sort-direction="defaultSortOrder"
        :default-sort="[sortField, sortOrder]"
        @sort="onSort"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" sortable numeric>{{ props.row.id }}</b-table-column>
          <b-table-column field="email" label="Email" sortable>{{ props.row.email }}</b-table-column>
          <b-table-column field="createdAt" label="Joined Date" sortable>{{ toLocalDateString(userActiveSubscriptionRecord(props.row)?.createdAt) }}</b-table-column>
          <b-table-column field="accountType" label="Type">{{ shortenServiceLabel(serviceLabel(props.row.accountType)) }}</b-table-column>
          <b-table-column label="Cancelled on">
            {{ userLastCancelledOn(props.row) }}
          </b-table-column>
          <b-table-column field="activeSubscription" label="Active">
            {{ isFreeUser(props.row) ? 'Free user' : ( props.row.activeSubscriber || props.row.activeSubscription ? 'Yes' : 'No' ) }}
          </b-table-column>
          <b-table-column field="campaign_manager" label="Campaign Manager" sortable style="text-transform: Capitalize;">{{ props.row.campaignManager || `${WHITE_GLOVE_DEFAULT_CAMPAIGN_MANAGER} (default)` }}</b-table-column>
          <b-table-column label="First transaction date">{{ firstTransactionDate(props.row) }}</b-table-column>
          <b-table-column label="Last transaction date">{{ lastTransactionDate(props.row) }}</b-table-column>
          <b-table-column label="Last transaction amount">{{ lastTransactionAmount(props.row) }}</b-table-column>
          <b-table-column label="Total amount paid Lifetime">{{ formatCurrency(totalAmountPaidLifetime(props.row)) }}</b-table-column>
        </template>
      </b-table>
    </div>

  </section>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

import { mixin as ExportMixin } from '@/components/export_mixin'
// import { mixin as BaseMixin } from '@/components/mixin'
import { mixin as ServiceMixin } from '@/components/service_mixin'
import { toLocalDateString, getPureServicePkgName, formatCurrency } from '@/utils'
import {
  freePlans,
  additionalSeatPlans,
  whiteGloveOnlyServices,
  WHITE_GLOVE_DEFAULT_CAMPAIGN_MANAGER,
} from "@/components/plans_constants"

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import service_package_constants from "@/components/service_package_constants"


const now = new Date()

export default {
  mixins: [ExportMixin, ServiceMixin],
  components: {DatePicker},
  data() {
    return {
      dates: [moment().subtract(1, 'months').toDate(), moment().toDate()],
      totalPaid: null,
      users: [],
      ready: true,
      progress: 0,
      sortField: 'id',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 10,
      totalRows: 0,
      editting: false,
      edittingRow: {},
      currentEmail: '',
      currentPayPalEmail: '',
      currentAccountType: '',
      currentAccountCoupon: '',
      currentAffiliateCredits: 0,
      currentIsAffiliate: false,
      currentIsNoDomainRestrictionOnFreeTrial: false,
      currentAllowWhiteGlovePurchase: false,
      currentAllowMissionControlAsSpecialSubAccount: false,
      isAffiliateChange: false,
      currentAffiliateExpiry: new Date(now.getFullYear() + 99, now.getMonth(), now.getDate()),
      currentAffiliateId: null,
      currentMonthlyCreditsFree: 0,
      currentRemainedMonthlyCreditsMonths: 0,
      currentIsBlockedByAdmin: false,

      searchText: '',
      filterField: 'email',
      perPageData: [],
      isSimple: false,
      isRounded: false,
      currentPage: 1,
      total: 0,
      isLoading: false, // this is not used because store loading is used so don't need
      createPurchase: false,
      currentAffiliatePercentage: 0.25,
      currentAffiliateCustomCode: '',
      currentAffiliateCoupons: [],
      adminCommentText: '',
      errorUpdatingUserMsg: '',

      purchaseDataForSubscriptionFind: [],
      selectedUser: null,
      selectedUserActiveSubscription: null,
      
      showDownloadByCancellationDateModal: false,
      downloadDateRange: [moment().subtract(3, 'months').toDate(), moment().toDate()],
    }
  },
  computed: {
    currentUser() {
      if (this.$store.state.user) {
        return this.$store.state.user
      }
      return {}
    },
    _() {
      return _
    },
    WHITE_GLOVE_DEFAULT_CAMPAIGN_MANAGER() {
      return WHITE_GLOVE_DEFAULT_CAMPAIGN_MANAGER
    }
  },
  methods: {
    formatCurrency: formatCurrency,
    isFreeUser (user) {
      if (!user) return false;
      if (freePlans.includes(user.accountType)) {
        return true;
      }
      if (user.isFreePeriodUser) {
        return true;
      }
      return false;
    },
    amountPaidPerMonth(user) {
      return service_package_constants?.[getPureServicePkgName(user?.lastActiveSubscription?.servicePackage)]?.price
    },
    whiteGloveFreePurchase(user) {
      const freePurchases = (user?.purchases || []).filter(purchase =>
        getPureServicePkgName(purchase?.servicePackage) === 'WHITE_GLOVE_FREE'
      )
      // Most recently created assignment, in case the plan was re-assigned.
      return _.maxBy(freePurchases, purchase => new Date(purchase.createdAt).getTime())
    },
    userActiveSubscriptionRecord(user) {
      // WHITE_GLOVE_FREE is assigned by admin without repointing activeSubscription
      // to the new purchase, so look the plan purchase up directly by service package.
      if (user?.accountType === 'WHITE_GLOVE_FREE') {
        return this.whiteGloveFreePurchase(user)
      }
      return user?.purchases?.find(purchase => purchase.id === user.activeSubscription)
    },
    whiteGloveInvoices(user) {
      const purchaseIds = (user?.purchases || []).filter(purchase => (
        whiteGloveOnlyServices.includes(getPureServicePkgName(purchase?.servicePackage))
        || whiteGloveOnlyServices.includes(getPureServicePkgName(purchase?.purchaseMetadata?.packageName))
      )).map(purchase => purchase.id)

      return (user?.invoices || []).filter(invoice => purchaseIds.includes(invoice.purchaseId))
    },
    lastTransaction(user) {
      const invoices = this.whiteGloveInvoices(user)
      return invoices?.[0]
    },
    firstTransaction(user) {
      const invoices = this.whiteGloveInvoices(user)
      if (!invoices?.length) return undefined
      return invoices[invoices.length - 1]
    },
    firstTransactionDate(user) {
      const invoice = this.firstTransaction(user)
      return invoice?.created || ''
    },
    lastTransactionDate(user) {
      const invoice = this.lastTransaction(user)
      return invoice?.created || ''
    },
    lastTransactionAmount(user) {
      const invoice = this.lastTransaction(user)
      if (invoice?.amountPaid) {
        return formatCurrency(invoice.amountPaid)
      }
      return ''
    },
    totalAmountPaidLifetime(user) {
      return this.whiteGloveInvoices(user)
        .map(invoice => invoice.amountPaid || 0)
        .reduce((partialSum, a) => partialSum + a, 0)
    },
    userLastCancelledOn(user) {
      if (!user || user.activeSubscriber) {
        return ''
      }
      try {
        let cancelledOn = ''
        for (let p of user.purchases) {
          if (!freePlans.includes(p.servicePackage) && p.subscriptionId && !additionalSeatPlans.includes(getPureServicePkgName(p.servicePackage))) {
            if (p.cancelledOn) {
              cancelledOn = p.cancelledOn
              break
            }
          }
        }
        return cancelledOn
      } catch (e) { }
      return 'null';
    },
    onFilter () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    onPageChange (page) {
      this.page = page
      this.$nextTick(() => {
        this.loadData()
      })
    },
    onSort (field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadData()
    },
    loadData () {
      this.$store.commit('showLoading')

      let startDate = this.dates[0]?moment(this.dates[0]).startOf('day').toDate():null;
      let endDate = this.dates[1]?moment(this.dates[1]).endOf('day').toDate():null;

      let params = [
        `sortField=${this.sortField}`,
        `sortOrder=${this.sortOrder}`,
        `page=${this.page}`,
        `perPage=${this.perPage}`,
        `filterField=${this.filterField}`,
        `filterText=${this.searchText.replace(/\s+/g, '')}`, // remove all white space before searching. case will be ignored on server side
        `accountType=white_glove`,
      ]

      if (startDate) {
        params.push(`startDate=${startDate.getTime()}`)
      }
      if (endDate) {
        params.push(`endDate=${endDate.getTime()}`)
      }

      params = params.join('&')

      return this.$store.dispatch('loadUsersForAdmin', { params })
        .then((response) => {
          const { users, totalUsers, totalPaid } = response.data
          this.users = users
          this.total = totalUsers
          this.totalPaid = totalPaid
        })
        .catch((err) => {
          console.log('Error fetching admin users ', err)
        })
        .finally(() => {
          this.loading = false
          this.$store.commit('hideLoading')
        })
    },
    toLocalDateString (dateStr) {
      return toLocalDateString(dateStr)
    },
    setCurrentAccountCoupon (event) {
      this.currentAccountCoupon = event.target.value
      this.createPurchase = true
    },
    exportCsv () {

      this.$store.commit('showLoading')
      const params = [
        `sortField=${this.sortField}`,
        `sortOrder=${this.sortOrder}`,
        `page=1`,
        `perPage=${this.total}`,
        `filterField=${this.filterField}`,
        `filterText=${this.searchText.replace(/\s+/g, '')}`, // remove all white space before searching. case will be ignored on server side
        `accountType=white_glove`,
      ].join('&')
      return this.$store.dispatch('loadUsersForAdmin', { params })
        .then((response) => {
          let csvData = [[
            'ID',
            'Email',
            'Joined Date',
            'Account Type',
            'Cancelled on',
            'Active',
            'Campaign Manager',
            'First transaction date',
            'Last transaction date',
            'Last transaction amount',
            'Total amount paid Lifetime',
          ].join(',')]
          response.data.users.forEach((u) => {
            csvData.push([
              u.id,
              u.email,
              this.userActiveSubscriptionRecord(u)?.createdAt ? moment.utc(this.userActiveSubscriptionRecord(u)?.createdAt).format() : '',
              this.shortenServiceLabel(this.serviceLabel(u.accountType)),
              this.userLastCancelledOn(u),
              this.isFreeUser(u) ? 'Free user' : ( u.activeSubscriber || u.activeSubscription ? 'Yes' : 'No' ),
              u.campaignManager || `${WHITE_GLOVE_DEFAULT_CAMPAIGN_MANAGER} (default)`,
              this.firstTransactionDate(u),
              this.lastTransactionDate(u),
              this.lastTransactionAmount(u).replace(',', ''),
              this.formatCurrency(this.totalAmountPaidLifetime(u)).replace(',', '')
            ].join(','))
          })
          const fileName = `WhiteGlove_Users_${now.getUTCFullYear()}_${(now.getUTCMonth()+1)}_${now.getUTCDate()}_Page${this.page}.csv`
          this.exportToCSV(csvData.join('\n'), fileName)
        })
        .catch((err) => {
          console.log('Error fetching admin users ', err)
        })
        .finally(() => {
          this.loading = false
          this.$store.commit('hideLoading')
        })
    },
    shortenServiceLabel(label) {
      if (label === 'White Glove Plan Unlimited Monthly (5 Sub Accounts / Available to add more seats)') {
        return 'White Glove Plan'
      }
      return label
    },
    onClickPage(pageNum) {
      this.current = pageNum;
      this.perPageData = this.$store.state.allUsers.slice(this.perPage * (pageNum - 1), pageNum * this.perPage)
    },
    changeSearchText() {
      if (!this.searchText) {
        this.current = 1;
        this.total = this.$store.state.allUsers.length;
        this.perPageData =  this.$store.state.allUsers.slice(0, this.perPage);

      } else {
        const searchData = this.users.filter((u) => {
          const acctType = u.accountType === 'trial' ? 'Trial' : u.accountType === 'gold' ? 'Pay As You Go' : 'Unlimited'
          const toSearch = `${acctType} ${u.email} ${u.accountBalance} ${u.accountCoupon}`.toLowerCase()
          return toSearch.indexOf(this.searchText.toLowerCase()) > -1
        });
        this.current = 1;
        this.total = Math.ceil(searchData.length / this.perPage);
        this.perPageData = searchData.slice(0, this.perPage);
      }
    },
  },
  beforeMount () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
.table-mobile-sort {
  display: none;
}

</style>
